import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';
import type { Action } from '@reduxjs/toolkit';
import LogRocket from 'logrocket';
import type { ThunkAction } from 'redux-thunk';

import { ENABLE_REDUX_DEV_TOOLS } from 'src/constants';

import rootReducer from './rootReducer';

export type State = ReturnType<typeof rootReducer>;

const store = configureStore({
  reducer: rootReducer,
  devTools: ENABLE_REDUX_DEV_TOOLS,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(LogRocket.reduxMiddleware() as ReturnType<typeof getDefaultMiddleware>), // https://github.com/reduxjs/redux-toolkit/issues/368#issuecomment-878018388
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, undefined, Action<string>>;

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export const useDispatch = (): AppDispatch => useReduxDispatch<AppDispatch>();

export default store;
